// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"886":"6f0d4497","957":"d04c76bf"}[chunkId] + ".chunk.css";
};